export default {
  // Module title
  otpPerformance: 'On-Time Performance',

  // Tab labels
  byDate: 'by Date',
  byRoute: 'by Route',
  byStops: 'by Stops',

  // Filter labels
  dateRange: 'Date Range',
  routes: 'Routes',
  allRoutes: 'All Routes',
  drivers: 'Drivers',
  allDrivers: 'All Drivers',
  direction: 'Direction',
  allDirections: 'All Directions',
  inbound: 'Inbound',
  outbound: 'Outbound',
  loop: 'Loop',
  stopType: 'Stop Type',
  firstStopOnly: 'First Stop Only',
  allStops: 'All Stops',
  lastStopOnly: 'Last Stop Only',

  // Threshold
  lateArrivalThreshold: 'Late Threshold',

  // Sort options
  sortBy: 'Sort By',
  onTimeAscending: 'On Time (Ascending)',
  onTimeDescending: 'On Time (Descending)',
  lateAscending: 'Late (Ascending)',
  lateDescending: 'Late (Descending)',
  earlyAscending: 'Early Departure (Ascending)',
  earlyDescending: 'Early Departure (Descending)',

  // Status labels
  late: 'Late',
  lateArrival: 'Late',
  onTime: 'On Time',
  early: 'Early',
  earlyDeparture: 'Early Departure',
  skipped: 'Skipped',
  leftBehind: 'Left Behind',
  otherRoutes: 'Other routes ({count})',
  riders: 'Riders',

  // Metrics
  onTimePerformance: 'On Time Performance',
  totalStops: 'Total Stops',
  total: 'Total',
  stops: 'Stops',
  maxLateDeviation: 'Max. Late Deviation',
  maxEarlyDeviation: 'Max. Early Deviation',
  mins: 'mins',

  // Chart labels
  otpDeviationMin: 'OTP Deviation (min)',
  lateDeviationMin: 'Late Deviation (min)',
  earlyDeviationMin: 'Early Deviation (min)',
  onTimePerformancePercent: 'On-Time Performance (%)',
  lateArrivalThresholdLabel: 'Late Threshold',
  minutes: 'minutes',

  // Actions
  showMore: 'Show More',
  showLess: 'Show Less',
  viewRoute: 'View Route',

  // Tooltip labels
  lateArrivalStops: 'Late Arrival Stops',
  earlyDepartureStops: 'Early Departure Stops',
  skippedStops: 'Skipped Stops',
  totalDepartures: 'Total Departures',

  // Percentages
  percentage: '%',

  // Messages
  noDataAvailable: 'No data available for the selected filters',
  noTripsOnDate: 'No trips on this date',
  noTripsInPeriod: 'No trips in this period',
  loadingData: 'Loading data...',
  errorLoadingData: 'Error loading data. Please try again.',
  backToRoutes: 'Back to routes',
};
